module.exports = __webpack_public_path__ + "static/java-46e865dc406d6bc44b8150d6391dd04c.png";